module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "connectedUser__container"
  }, [_c('div', {
    staticClass: "ui items"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "ui mini image"
  }, [_c('img', {
    attrs: {
      "src": _vm.currentUser.photoURL,
      "alt": "avatar"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned content"
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n                        " + _vm._s(_vm.currentUser.displayName) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "extra"
  }, [_c('button', {
    staticClass: "ui circular icon right floated button",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "icon sign out"
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-082f32d7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/ConnectedUser.vue
// module id = 218
// module chunks = 1